import { useEffect } from 'react';
import { getAuth } from 'firebase/auth';

import { useAppDispatch } from 'app/hooks';

import {
  setTours,
  logIn,
  logOut,
  fetchUser,
  setProviders,
  setIsAuthLoading,
  fetchTours,
} from 'app/services/redux/slices';

export function useAuthStateChanged(): void {
  const dispatch = useAppDispatch();
  const auth = getAuth();

  useEffect(() => {
    auth.onAuthStateChanged(async (user) => {
      dispatch(setIsAuthLoading(true));

      // login
      if (user && !user.isAnonymous) {
        const userData = await dispatch(fetchUser()).unwrap();
        const token = await user.getIdToken();
        const providers = user.providerData.reduce(
          (providers: string[], p) =>
            p ? [...providers, p.providerId] : providers,
          [],
        );

        dispatch(
          logIn({
            displayName: user.displayName,
            email: user.email,
            token,
            providers,
          }),
        );
        dispatch(setProviders(providers));

        if (userData) {
          dispatch(fetchTours(userData));
        }
      }

      // logout
      if (!user) {
        dispatch(logOut());
        dispatch(setTours([]));
      }

      dispatch(setIsAuthLoading(false));
    });
  }, [auth, dispatch]);
}
